import React, { ComponentType, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/App/hooks';
import { getConsultationsThunk } from '@/features/i18n/i18nSlice';
import { selectLocale } from '@/features/i18n/selectLocale';
import { selectResources } from '@/features/i18n/selectResources';

export interface WithConsultationsTextProps {
  text: string;
}

export const withConsultationsText = <T extends object>(
  WrappedComponent: ComponentType<T & WithConsultationsTextProps>,
) => {
  const HOC = (props: T) => {
    const dispatch = useAppDispatch();
    const locale = useAppSelector(selectLocale);
    const resources = useAppSelector(selectResources);
    const { consultations } = resources;

    useEffect(() => {
      if (!consultations.initialized && locale) {
        dispatch(getConsultationsThunk(locale));
      }
    }, [dispatch, consultations, locale]);

    if (!consultations.initialized || !locale) {
      return null;
    }

    return <WrappedComponent text={consultations.text} {...props} />;
  };
  HOC.displayName = `withConsultationsText(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return HOC;
};
